/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			if (this.dataset.loading === 'true' || this.classList.contains('product-recommendations--loaded')) return;

			this.dataset.loading = 'true';
			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						this.querySelectorAll('.lazyload').forEach((image) => {
							lazySizes.loader.unveil(image);
						});
					}

					this.classList.add('product-recommendations--loaded');
					delete this.dataset.loading;

				})
				.catch(e => {
					delete this.dataset.loading;
					console.error(e);
				});
		}
		connectedCallback() {
			if (!this.dataset.url || this.classList.contains('product-recommendations--loaded')) return;

			if ('IntersectionObserver' in window) {
				this.observer = new IntersectionObserver((entries) => {
					if (!entries.some((entry) => entry.isIntersecting)) return;

					this.observer.disconnect();
					this.fetchProducts();
				}, {
					rootMargin: '400px 0px',
					threshold: 0
				});
				this.observer.observe(this);
			} else {
				this.fetchProducts();
			}
		}
		disconnectedCallback() {
			this.observer?.disconnect();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
